// extracted by mini-css-extract-plugin
export var btn = "cost-module--btn--b3978";
export var cost = "cost-module--cost--77730";
export var newcost = "cost-module--newcost--750af";
export var oldcost = "cost-module--oldcost--55839";